module.exports = __webpack_public_path__ + "static/media/channelimgthree.4a470f33.png";